import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

import {RequestParameters} from '../shared/models/request-parameters/parameter.model';
import { parseHttpErrorBody } from '../shared/forms/parse-http-error-body';
import {GlobalVariable} from '../global';
import {CallCenter} from './call-center.model';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class CallCenterService {
  private subject = new Subject<any>();
  constructor(private http: HttpClient) {
  }

  getCallCenters (parameters: RequestParameters = new RequestParameters()) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/call-centers', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  getCallCenter (reference: string) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/call-center/' + reference, {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  postCallCenter (callCenter: CallCenter) {

    const body = this.normalizeCallCenterData(callCenter);

    return this.http.post(GlobalVariable.BASE_API_URL + '/call-centers', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  putCallCenter (callCenter: CallCenter) {

    const body = this.normalizeCallCenterData(callCenter);

    return this.http.put(GlobalVariable.BASE_API_URL + '/call-center/' + callCenter.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  deleteCallCenter (callCenter: CallCenter) {
    return this.http.delete(GlobalVariable.BASE_API_URL + '/call-center/' + callCenter.reference)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }
  disableCallCenter(callCenter: CallCenter, stateToApply) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/call-center/' + callCenter.reference + '/' + stateToApply)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }
  private normalizeCallCenterData(callCenter: CallCenter): CallCenter {
    const body = Object.assign({}, callCenter);
    delete body.reference;
    if (body.country !== null) {
      body.country = body.country.reference;
    }
    if (body.manager !== null) {
      body.manager = body.manager.reference;
    }

    return body;
  }
  emitMessage(msg: object) {
    this.subject.next(msg);
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/call-center/call-center.service.ts